module.exports = __webpack_public_path__ + "img/pic23.66eeba59.png";